/**
 * Single source of truth for React Query keys used by profile fetching and cache updates.
 */
export const profileQueryKeys = {
  byUserAndWorkspace: (
    userId: string | undefined,
    workspaceId: string | null | undefined,
  ) => ['profile', userId, workspaceId ?? null] as const,
} as const;
